import {captureException, captureMessage, withScope} from '@sentry/browser';
import {BiError} from '../biErrorLogger/biErrorLoggerFactory';

export function logException(reason: Error | string, extra: Record<string, any>, bi: BiError) {
  withScope((scope) => {
    scope.setTags({
      biId: bi.id,
      biName: bi.name,
    });
    scope.setExtras(extra);
    if (typeof reason === 'string') {
      captureMessage(reason);
    } else {
      captureException(reason);
    }
  });
}
